<template>
  <!-- v-resize="onResize" -->
  <div>
    <div style="text-align: center">
      <v-progress-circular
        v-if="loading == true"
        class="orange--text"
        :size="200"
        :width="16"
        indeterminate
        style="margin: auto"
      >
        <span
          ><strong class="orange--text">
            <h2>Cargando...</h2>
          </strong></span
        >
      </v-progress-circular>
    </div>
    <v-container v-if="tracking" class="contenedor">
      <v-slide-y-transition>
        <template>
          <v-stepper
            non-linear
            alt-labels
            v-model="infoStatus"
            transition="fade"
          >
            <v-stepper-header class="blue2">
              <v-row
                class="align-center justify-center"
                style="flex: auto; margin: auto"
              >
                <v-col cols="1">
                  <router-link :to="{ name: 'empresas' }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <strong>
                          <v-icon
                            color="orange"
                            large
                            v-on="on"
                            @click="volver()"
                            style="border-radius: 100%; border: 4px solid"
                            class="orange--text"
                            >mdi-arrow-left</v-icon
                          >
                        </strong>
                      </template>
                      <span>Volver</span>
                    </v-tooltip>
                  </router-link>
                </v-col>
                <v-col cols="2">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :class="{ 'on-hover': hover }"
                      class="blue2 card-test"
                    >
                      <div class="mt-3" :complete="lastStatus >= 1" step="1">
                        <v-img
                          contain
                          height="70"
                          width="70"
                          :src="
                            lastStatus < 1
                              ? require('@/assets/CheckBox-8.png')
                              : require('@/assets/Success_Prepared@2x.png')
                          "
                        />
                        <div class="justify-center">
                          <p
                            class="body-2"
                            :class="
                              lastStatus >= 1 ? 'textSuccess' : 'textStandby'
                            "
                          >
                            <strong class="font-weight-black">
                              {{
                                lastStatus >= 1 ? "PREPARADO" : "EN PREPARACION"
                              }}</strong
                            >
                          </p>
                        </div>
                      </div>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-col cols="1">
                  <div class="icon-flecha">
                    <v-icon
                      :x-large="windowX >= 10"
                      :small="windowX < 10"
                      :color="lastStatus > 2 ? '#3bda10' : '#919191'"
                      >mdi-arrow-right-bold-outline</v-icon
                    >
                  </div>
                </v-col>
                <v-col cols="2">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :class="{ 'on-hover': hover }"
                      class="blue2 card-test"
                    >
                      <div :complete="lastStatus > 2" step="2">
                        <v-img
                          contain
                          height="80"
                          width="80"
                          :src="
                            lastStatus > 2
                              ? require('@/assets/Success_ReceivedToTransport@2x.png')
                              : require('@/assets/Pre-reception@2x.png')
                          "
                        />
                        <div class="justify-center">
                          <p
                            class="body-2"
                            :class="
                              lastStatus > 2 ? 'textSuccess' : 'textStandby'
                            "
                          >
                            <strong class="font-weight-black">{{
                              lastStatus > 2
                                ? "TRANSPORTE"
                                : "PRE-RECEPCIÓN TRANSPORTE"
                            }}</strong>
                          </p>
                        </div>
                      </div>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-col cols="1">
                  <div class="icon-flecha">
                    <v-icon
                      :x-large="windowX >= 100"
                      :small="windowX < 100"
                      :color="lastStatus > 2 ? '#3bda10' : '#919191'"
                      >mdi-arrow-right-bold-outline</v-icon
                    >
                  </div>
                </v-col>
                <v-col cols="2">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :class="{ 'on-hover': hover }"
                      class="blue2 card-test"
                    >
                      <div :complete="lastStatus > 3" step="3">
                        <v-img
                          contain
                          height="80"
                          width="80"
                          :src="
                            lastStatus > 3
                              ? require('@/assets/Success_TruckDelivery@2x.png')
                              : require('@/assets/TruckDelivery@2x.png')
                          "
                        />
                        <div class="justify-center">
                          <p
                            class="body-2"
                            :class="
                              lastStatus > 3 ? 'textSuccess' : 'textStandby'
                            "
                          >
                            <strong class="font-weight-black">{{
                              lastStatus > 3 ? "EN RUTA" : "RUTA EN ESPERA"
                            }}</strong>
                          </p>
                        </div>
                      </div>
                    </v-card>
                  </v-hover>
                </v-col>
                <v-col cols="1">
                  <div class="icon-flecha">
                    <v-icon
                      :x-large="windowX >= 100"
                      :small="windowX < 100"
                      :color="
                        lastStatus > 5
                          ? 'red'
                          : lastStatus > 4
                          ? '#3bda10'
                          : '#919191'
                      "
                      >mdi-arrow-right-bold-outline</v-icon
                    >
                  </div>
                </v-col>
                <v-col cols="2">
                  <v-hover v-slot="{ hover }">
                    <v-card
                      :class="{ 'on-hover': hover }"
                      class="blue2 card-test"
                    >
                      <div
                        :complete="lastStatus > 4"
                        :rules="[() => lastStatus < 6]"
                        step="4"
                      >
                        <v-img
                          contain
                          height="80"
                          width="80"
                          :src="
                            lastStatus < 5
                              ? require('@/assets/Box-8.png')
                              : lastStatus > 5
                              ? require('@/assets/Failed_Box@2x.png')
                              : require('@/assets/Success_Box@2x.png')
                          "
                        />
                        <div class="justify-center">
                          <p
                            class="body-2"
                            :class="
                              lastStatus > 5
                                ? 'textError'
                                : lastStatus > 4
                                ? 'textSuccess'
                                : 'textStandby'
                            "
                          >
                            <strong class="font-weight-black">{{
                              lastStatus > 5 ? "NO ENTREGADO" : "ENTREGADO"
                            }}</strong>
                          </p>
                        </div>
                      </div>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                v-for="(status, i) in Cabeceras"
                :key="status.Id_Tracking"
                :index="i"
                :step="i"
              >
                <v-card
                  class="pa-3 mb-5"
                  outlined
                  flat
                  align="center"
                  color="#e7e7e7"
                >
                  <v-col
                    cols="12"
                    class="d-flex align-center content-info"
                    style="justify-content: space-around"
                  >
                    <v-row justify="center">
                      <v-col cols="3">
                        <div v-if="imageData">
                          <img
                            :src="imageData.logo2"
                            :alt="imageData.nombre"
                            style="border-radius: 25px; width: 200px"
                          /></div
                      ></v-col>
                      <v-col cols="6">
                        <div class="ml-2" style="min-width: 200px">
                          <span
                            class="text-subtitle-2 text--primary text-center"
                          >
                            <strong>Nº de Orden: {{ idOrden }} </strong> </span
                          ><br />
                          <span class="text-body-2 text--primary text-center">
                            <strong>{{ status.Desc_Tracking }}</strong>
                          </span>
                          <v-divider></v-divider>
                          <span
                            class="text-subtitle-2 text-center text--primary"
                          >
                            <strong>{{
                              status.Detalles.length > 0
                                ? infoStatus > 1
                                  ? "Estados informados por Courier"
                                  : "Información adicional"
                                : "Sin detalles adicionales"
                            }}</strong>
                          </span>
                          <v-spacer></v-spacer>
                          <span
                            class="text-subtitle-2 text-center text--primary"
                            v-if="
                              fecha_solicitada != null &&
                              !storerkeyBLUE.includes('I00153')
                            "
                          >
                            <strong
                              >Fecha Entrega Estimada:
                              {{ fecha_solicitada }}</strong
                            >
                          </span>
                          <span
                            class="text-subtitle-2 text-center text--primary"
                            v-if="
                              fecha_solicitada != null &&
                              storerkeyBLUE.includes('I00153')
                            "
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                              text-align: left;
                            "
                          >
                            <v-row justify="center">
                              <v-col cols="3"></v-col>
                              <v-col cols="4" class="mt-6">
                                <p>Seguir mi pedido por:</p>
                              </v-col>
                              <v-col cols="2" align="center">
                                <a
                                  :href="
                                    'https://www.blue.cl/seguimiento/?n_seguimiento=' +
                                    NroEnvio
                                  "
                                  target="_blank"
                                >
                                  <img
                                    :src="'https://bx-dev-website.s3.us-west-2.amazonaws.com/XagJ6A1y-Blue-Express-Copec.svg'"
                                    alt="Imagen"
                                    width="80"
                                    height="80"
                                  /> </a
                              ></v-col>
                              <v-col cols="3"></v-col>
                            </v-row>
                          </span>
                          <v-spacer></v-spacer></div
                      ></v-col>
                      <v-col cols="3">
                        <v-img
                          class="ml-4"
                          el
                          cliente
                          contain
                          max-height="120"
                          max-width="120"
                          :src="
                            infoStatus > 5
                              ? require('@/assets/Failed_Box@2x.png')
                              : infoStatus > 4
                              ? require('@/assets/Success_Box@2x.png')
                              : infoStatus > 3
                              ? require('@/assets/Success_TruckDelivery@2x.png')
                              : infoStatus > 2
                              ? require('@/assets/Success_ReceivedToTransport@2x.png')
                              : infoStatus > 1
                              ? require('@/assets/DeepGray_ReceivedToTransport@2x.png')
                              : infoStatus > 0
                              ? require('@/assets/Success_Box@2x.png')
                              : require('@/assets/CheckBox.svg')
                          "
                      /></v-col>
                    </v-row>
                  </v-col>
                  <v-divider></v-divider>
                  <template>
                    <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                      <v-timeline-item
                        color="orange"
                        fill-dot
                        v-for="(cStatus, i) in myJSON.Historico"
                        :index="i"
                        v-if="cStatus.SUBESTADO.length > 0"
                      >
                        <template>
                          <v-card
                            v-if="cStatus.SUBESTADO.length > 0"
                            class="orange card-test"
                            style="
                              padding: 3%;
                              border-top-left-radius: 25px;
                              border-bottom-right-radius: 25px;
                            "
                          >
                            <h3
                              class="white--text d-flex align-center justify-space-between"
                            >
                              <strong style="font-size: 20px">
                                {{
                                  capitalizarPrimerasLetras(cStatus.ESTADO)
                                }}&nbsp;&nbsp;&nbsp;&nbsp;
                              </strong>

                              <strong
                                class="align-center justify-center text-body-2 white--text"
                                @click="
                                  verDetalle(cStatus.SUBESTADO, i);
                                  reveal = false;
                                "
                                style="
                                  padding: 5px;
                                  border: 2px solid white;
                                  border-radius: 10px;
                                "
                              >
                                <strong>SubEstados &nbsp;</strong>
                                <v-icon
                                  small
                                  class="white--text"
                                  style="border: 2px solid; border-radius: 25px"
                                >
                                  {{
                                    showSubEstados[i]
                                      ? "mdi-chevron-up"
                                      : "mdi-chevron-down"
                                  }}
                                </v-icon>
                              </strong>
                            </h3>
                            <v-card-text style="padding: 1%">
                              <v-expand-transition class="white text--primary">
                                <div v-show="showSubEstados[i]">
                                  <!-- <v-container
                                    ><v-divider></v-divider
                                  ></v-container> -->
                                  <v-card-text>
                                    <v-card
                                      style="
                                        border-top-left-radius: 25px;
                                        border-bottom-right-radius: 25px;
                                        margin-top: 2%;
                                        padding: 2%;
                                      "
                                      class="card-test"
                                      color="blue2"
                                      v-for="(
                                        cSubStates, indexSubState
                                      ) in cStatus.SUBESTADO"
                                      :index="indexSubState"
                                    >
                                      <h5 class="d-flex ml-2 white--text">
                                        <span style="font-size: 16px"
                                          ><v-icon class="grey--text"
                                            >mdi-information-outline</v-icon
                                          >
                                          {{
                                            capitalizarPrimerasLetras(
                                              cSubStates.Estado
                                            )
                                          }}</span
                                        >
                                      </h5>
                                      <v-card-text class="white text--primary">
                                        <v-row justify="center" dense>
                                          <table
                                            style="
                                              font-size: 15px;
                                              background-color: #ffffff;
                                              border-radius: 10px;
                                              width: 100%;
                                              max-width: 600px;
                                              overflow: hidden;
                                              border-collapse: separate;
                                              border-spacing: 0;
                                              box-shadow: 0px 4px 10px
                                                rgba(0, 0, 0, 0.1);
                                            "
                                          >
                                            <tr
                                              v-if="cSubStates.Fecha.length > 0"
                                              style="
                                                border-bottom: 1px solid #e0e0e0;
                                              "
                                            >
                                              <th
                                                class="text-left pa-2"
                                                style="
                                                  background-color: #f2f2f2;
                                                  font-weight: bold;
                                                  width: 30%;
                                                "
                                              >
                                                Fecha:
                                              </th>
                                              <td class="pa-2 text-left">
                                                {{ cSubStates.Fecha }}
                                              </td>
                                            </tr>
                                            <tr
                                              v-if="
                                                cSubStates.Pedido.length > 0
                                              "
                                              style="
                                                border-bottom: 1px solid #e0e0e0;
                                              "
                                            >
                                              <th
                                                class="text-left pa-2"
                                                style="
                                                  background-color: #f2f2f2;
                                                  font-weight: bold;
                                                  width: 30%;
                                                "
                                              >
                                                Pedido:
                                              </th>
                                              <td class="pa-2 text-left">
                                                {{ cSubStates.Pedido }}
                                              </td>
                                            </tr>
                                            <tr
                                              v-if="
                                                cSubStates.Cliente.length > 0
                                              "
                                              style="
                                                border-bottom: 1px solid #e0e0e0;
                                              "
                                            >
                                              <th
                                                class="text-left pa-2"
                                                style="
                                                  background-color: #f2f2f2;
                                                  font-weight: bold;
                                                  width: 30%;
                                                "
                                              >
                                                Cliente:
                                              </th>
                                              <td class="pa-2 text-left">
                                                {{ cSubStates.Cliente }}
                                              </td>
                                            </tr>
                                            <tr
                                              v-if="
                                                cSubStates.Estado_Loginsa > 0
                                              "
                                              style="
                                                border-bottom: 1px solid #e0e0e0;
                                              "
                                            >
                                              <th
                                                class="text-left pa-2"
                                                style="
                                                  background-color: #f2f2f2;
                                                  font-weight: bold;
                                                  width: 30%;
                                                "
                                              >
                                                Loginsa:
                                              </th>
                                              <td class="pa-2 text-left">
                                                {{ cSubStates.Estado_Loginsa }}
                                              </td>
                                            </tr>
                                            <tr
                                              v-if="
                                                cSubStates.Subestado != null &&
                                                cSubStates.Subestado != ''
                                              "
                                              style="
                                                border-bottom: 1px solid #e0e0e0;
                                              "
                                            >
                                              <th
                                                class="text-left pa-2"
                                                style="
                                                  background-color: #f2f2f2;
                                                  font-weight: bold;
                                                  width: 30%;
                                                "
                                              >
                                                Descripción:
                                              </th>
                                              <td class="pa-2 text-left">
                                                {{ cSubStates.Subestado }}
                                              </td>
                                            </tr>
                                            <!-- <tr
                                              v-if="cSubStates.Fotos.length > 0"
                                            >
                                              <td
                                                colspan="2"
                                                class="pa-2 text-center"
                                              ></td>
                                            </tr> -->
                                          </table>
                                        </v-row>
                                        <v-btn
                                          v-if="cSubStates.Fotos.length > 0"
                                          text
                                          small
                                          class="orange rounded-pill mt-6"
                                          style="
                                            border: 1px solid #dcdcdc;
                                            padding: 5px 10px;
                                          "
                                          @click="reveal = !reveal"
                                        >
                                          <span
                                            class="white--text text-caption"
                                          >
                                            <strong>Ver Fotos</strong>
                                          </span>
                                        </v-btn>
                                      </v-card-text>
                                    </v-card>
                                  </v-card-text>
                                </div>
                              </v-expand-transition>
                            </v-card-text>
                          </v-card>
                          <br />
                          <v-expand-transition>
                            <div v-if="reveal">
                              <div
                                v-for="(imagenCon, ind) in cStatus.SUBESTADO"
                              >
                                <v-card
                                  v-if="imagenCon.Fotos.length > 0"
                                  style="
                                    border-top-left-radius: 25px;
                                    border-bottom-right-radius: 25px;
                                  "
                                  class="transition-fast-in-fast-out"
                                >
                                  <h3
                                    color="orange"
                                    class="orange"
                                    style="padding: 3%"
                                  >
                                    <strong class="d-flex white--text">
                                      Imagenes:
                                    </strong>
                                  </h3>
                                  <v-card-text class="orange text--primary">
                                    <v-list
                                      v-for="(
                                        imagenCon, ind
                                      ) in cStatus.SUBESTADO"
                                      class="white text--primary"
                                    >
                                      <v-list-item
                                        v-for="(
                                          imagenConvert, ind
                                        ) in imagenCon.Fotos"
                                        class="align-center justify-center"
                                      >
                                        <span v-if="imagenConvert.length > 300">
                                          <img
                                            class="v-card-image"
                                            :src="
                                              'data:image/jpeg;base64,' +
                                              imagenConvert
                                            "
                                          />
                                        </span>
                                        <span
                                          v-if="
                                            imagenConvert.length < 300 &&
                                            imagenConvert.length > 2
                                          "
                                        >
                                          <img
                                            class="v-card-image"
                                            :src="imagenConvert"
                                          />
                                        </span>
                                        <span v-if="imagenConvert.length <= 2">
                                          <strong
                                            >Sin Imagen para mostar</strong
                                          >
                                        </span>
                                      </v-list-item>

                                      <v-btn
                                        style="
                                          border-radius: 15px;
                                          border: 1px solid #ffffff;
                                        "
                                        class="orange mt-4"
                                        @click="reveal = false"
                                      >
                                        <strong class="white--text"
                                          >cerrar</strong
                                        >
                                      </v-btn>
                                    </v-list>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                          </v-expand-transition>
                        </template>
                      </v-timeline-item>
                    </v-timeline>
                  </template>
                  <v-divider></v-divider>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>
      </v-slide-y-transition>
    </v-container>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      storerkey: null,
      myJSON: [],
      estados: [
        "EN PREPARACIÓN",
        "PREPARADO",
        "EN PRE-RECEPCION TRANSPORTE",
        "RECIBIDO POR TRANSPORTE",
        "EN RUTA",
        "ENTREGADO",
        "NO ENTREGADO",
      ],
      storerkeyBLUE: ["I00153"],
      fecha_solicitada: null,
      NroEnvio: null,
      Cabeceras: [],
      Estado: [],
      showSubEstados: {},
      reveal: false,
      loading: true,
      error: false,
      tracking: false,
      infoTracking: null,
      lastStatus: null,
      infoStatus: null,
      showDetails: true,
      SUBESTADO: [],
      tcard: null,
      windowX: 0,
      windowY: 0,
      estadosAbiertos: {
        "EN PREPARACIÓN": false,
        PREPARADO: false,
        "EN PRE-RECEPCION TRANSPORTE": false,
        "RECIBIDO POR TRANSPORTE": false,
        "EN RUTA": false,
        ENTREGADO: false,
        "NO ENTREGADO": false,
      },
    };
  },
  computed: {
    ...mapState([
      "baseUrl",
      "token",
      "idTrack",
      "theme",
      "couriers",
      "selectedCourier",
    ]),
    imageData() {
      // Redirige a la ruta "empresas"
      if (this.$route.query.codigo == "I00211") {
        return this.selectedCourier || {};
      } else {
        let var_courier = this.couriers.find((courier) => {
          if (courier.id_cliente == this.$route.query.codigo) {
            return courier;
          }
        });
        //  this.setSelectedCourier(cliente);
        console.log(var_courier);
        console.log(this.couriers);
        return var_courier;
      }
    },
  },
  props: {
    idOrden: String,
    idCliente: String,
  },
  created() {
    if (this.theme == "light") {
      this.tcard = "tWhite";
    } else {
      this.tcard = "tBlack";
    }
    // if(this.couriers.length == 0){
    //   //buscamos a la api
    // }
    console.log(this.idCliente);
    console.log(this.$route.query.codigo);
  },
  mounted() {
    this.listarCouriers();
  },
  watch: {
    infoStatus: function () {},
    theme: function () {
      if (this.theme == "light") {
        this.tcard = "tWhite";
      } else {
        this.tcard = "tBlack";
      }
    },
    error: function () {
      if (this.error == true) {
        this.setIdTrack(null);
        this.setStorerKey(null);
        // this.$router.push({ name: "empresas", query: { codigo: this.idTest } });
      }
    },
    idOrden: {
      immediate: true,
      handler() {
        if (this.idOrden) {
          this.init();
        }
      },
    },
  },
  destroyed() {
    this.Cabeceras = [];
    this.Estado = [];
    this.error = false;
    this.tracking = false;
    this.infoTracking = null;
    this.lastStatus = null;
    this.infoStatus = null;
    this.showDetails = true;
    this.tcard = null;
  },
  methods: {
    //si clientes esta vacio en storer tiene que cargar la api, en el caso contrario solo muestra la data
    ...mapMutations([
      "setIdTrack",
      "setStorerKey",
      "setBuscador",
      "setSelectedCourier",
    ]),
    listarCouriers() {
      this.$store.dispatch("listarCouriers");
    },

    // mapCliente(){
    //   this.storerkey = this.couriers.map(couriers=>{if (couriers.storerkey === )})
    // },
    verDetalle(value, i) {
      this.SUBESTADO = value;
      this.$set(this.showSubEstados, i, !this.showSubEstados[i]);
      this.subEstadosDetalle = this.SUBESTADO.map((element) => {
        return {
          Cliente: element.Cliente,
          Estado: element.Estado,
          Estado_Loginsa: element.Estado_Loginsa,
          Fecha: element.Fecha,
          Fotos: element.Fotos,
          Pedido: element.Pedido,
          Subestado: element.Subestado,
        };
      });
    },
    async init() {
      this.Cabeceras = [];
      let index = 0;
      this.estados.forEach((estado) => {
        index += 1;
        let item = {
          Id_Tracking: index,
          Desc_Tracking: estado,
          Detalles: [],
        };
        this.Cabeceras.push(item);
      });
      await this.getInfoTracking();
      this.obtenerPedido();
    },
    volver() {
      this.setBuscador(true);
      this.tracking = false;
      this.error = false;
    },
    //OBTENGO EL ESTADO EN EL QUE SE ENCUENTRA EL PEDIDO
    async getInfoTracking() {
      try {
        // let replay = this.baseUrl + "?cliente=" + this.idCliente;
        // console.log(this.idCliente);
        // console.log(this.idOrden);
        let storerkey =
          this.idCliente == null ? this.idCliente : this.$route.query.codigo;
        let datos =
          this.baseUrl +
          "?cliente=" +
          this.sanitizeSqlInput(this.$route.query.codigo) +
          "&orden_externa=" +
          this.sanitizeSqlInput(this.idOrden);
        console.log(datos);

        axios
          .get(datos, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              let lastStatus;
              let status = response.data.data;
              this.fecha_solicitada = status.fecha_solicitada;
              this.NroEnvio = status.NroEnvio;
              if (status.Estado.length > 0) {
                lastStatus = status.Estado;
                if (lastStatus < 7) {
                  this.lastStatus = lastStatus - 1;
                  this.infoStatus = lastStatus - 1;
                }
                if (lastStatus == 7) {
                  this.lastStatus = lastStatus - 1;
                  this.infoStatus = lastStatus - 1;
                }
                this.tracking = true;
                this.error = false;
              } else {
                this.tracking = false;
                this.error = false;
              }
              Swal.fire({
                title: "Correcto!",
                text: "N° de Orden, encontrada con éxito",
                icon: "success",
                confirmButtonText: "Aceptar",
              });
            }
          })
          .catch((error) => {
            if (error.response.data.code == 403) {
              Swal.fire({
                title: "Error!",
                text: error.response.data.msj,
                icon: "error",
                confirmButtonText: "Aceptar",
              });
              this.$router.push({ name: "TrackingPedido" });
            }
            this.error = true;
            console.log(e);
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    sanitizeSqlInput(input) {
      console.log("esta es mi input sql inyect: " + input);

      if (!input) return "";

      let sanitized = input.replace(/'/g, "''");

      const sqlKeywords = [
        "--",
        ";--",
        ";",
        "/*",
        "*/",
        "@@",
        "char",
        "nchar",
        "varchar",
        "nvarchar",
        "alter",
        "begin",
        "cast",
        "create",
        "cursor",
        "declare",
        "delete",
        "drop",
        "exec",
        "execute",
        "fetch",
        "insert",
        "kill",
        "select",
        "sys",
        "sysobjects",
        "syscolumns",
        "table",
        "update",
        "union",
        "xp_",
      ];

      function escapeRegex(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }

      sqlKeywords.forEach((keyword) => {
        const escapedKeyword = escapeRegex(keyword);
        const regex = new RegExp(escapedKeyword, "gi");
        sanitized = sanitized.replace(regex, "");
      });

      console.log(
        "esto es lo que me devuelve mi input despues de la funcion: " +
          sanitized
      );

      return sanitized;
    },

    escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escapa caracteres especiales de regex
    },
    capitalizarPrimerasLetras(texto) {
      // Dividir el texto en un arreglo de palabras
      var palabras = texto.toLowerCase().split(" ");
      // Recorrer cada palabra y capitalizar la primera letra
      for (var i = 0; i < palabras.length; i++) {
        var palabra = palabras[i];
        palabras[i] = palabra.charAt(0).toUpperCase() + palabra.slice(1);
      }
      // Unir las palabras en un nuevo texto
      var textoCapitalizado = palabras.join(" ");
      return textoCapitalizado;
    },
    obtenerPedido() {
      try {
        let datos =
          this.baseUrl +
          "?cliente=" +
          this.sanitizeSqlInput(this.$route.query.codigo) +
          "&orden_externa=" +
          this.sanitizeSqlInput(this.idOrden);
        axios
          .get(datos, {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.code == 200) {
              this.myJSON = response.data.data;
              this.tracking = true;
            }
          })
          .catch((error) => {
            this.error = true;
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getLastStatus: function () {
      this.infoTracking.Cabeceras.forEach((estado) => {
        if (estado.Detalles.length > 0) {
          this.lastStatus = estado.Id_Tracking - 1;
          this.infoStatus = this.lastStatus - 1;
        }
      });
      this.tracking = true;
    },
    // onResize() {
    //   this.windowX = window.innerWidth;
    //   this.windowY = window.innerHeight;
    // },
  },
};
</script>
<style>
.contenedor {
  width: 70%;
  /* display: flex; */
  justify-content: center;
  /* margin: 2PX; */
  flex-wrap: wrap;
  padding: 1;
}

.texto-titulo {
  color: #111;
}

.resp span {
  color: black;
}

.img-p {
  width: 100px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-test {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-card-image {
  max-width: 100%;
  /* La imagen no será más ancha que la v-card */
  max-height: 100%;
  /* La imagen no será más alta que la v-card */
  display: block;
  /* Asegura que la imagen se ajuste al contenedor */
}

@media screen and (max-width: 960px) {
  .icon-flecha {
    display: none;
  }
}

@media screen and (max-width: 650px) {
  .content-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.v-progress-circular {
  margin: 1rem;
  justify-content: center;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: relative;
  width: 100%;
}
.v-application .white {
  background-color: #236192 !important;
  border-color: #ffffff !important;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0),
    0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0);
}
</style>
